import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q6nab24dj: FaireProductEntity = {
  token: "p_2q6nab24dj",
  type: "product",
  name: "ASOS Gauze Dress",
  brandToken: "b_hxanhsp4ja",
  brandName: "Studio Laloba",
  imageUrl:
    "https://cdn.faire.com/fastly/643cd0ff9531d2a7cd49a4e6a13dcbf2db96d2e1ce6fc05b48d71f6f2a57eabd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5e085c504868e648bf74c82cf0c1f057e415ebbb9c0f3d9d935bf3b7324de8a.jpeg",
    "https://cdn.faire.com/fastly/57a4a21ec8cbb18ed278396c7e96460e6207e36e3cbcdf6ba5b87d2ed0fabafe.jpeg",
    "https://cdn.faire.com/fastly/f59305ae4e78851e8930242065a5efae83a2197f4cca0910a3d7f7926b13a159.jpeg",
    "https://cdn.faire.com/fastly/265946aab3438be1e83a5f73e9fbafae39607ee927c159a710f2cf2214d92f27.jpeg",
    "https://cdn.faire.com/fastly/52c304c9b92ebb91f6f18a457346dc403e9c19a60e8cda359aeac55f6d18bc26.jpeg",
    "https://cdn.faire.com/fastly/d4538427171955d0a7f152b4cea961102dd5f810cef3d33e20c39bcde1d3678b.jpeg",
    "https://cdn.faire.com/fastly/8c3ceebd270b500a00ad5e530f2a5ecb39d524007587a7a8d879dd708c4191b8.jpeg",
    "https://cdn.faire.com/fastly/b93c7d79aa0175c043a19f071df1f1984b38173cfcd232e6ce6339e02f91d5f6.jpeg",
  ],
  priceDollars: 72,
  description:
    "Embrace effortless elegance with our Strappy Double Gauze Dress, the perfect blend of comfort and style. This versatile Long Beach Dress is designed to keep you cool and chic, whether you're lounging by the sea or attending a summer wedding.\n\nCrafted from high-quality cotton, this Backless Linen Dress features a breezy, sleeveless design that drapes beautifully, making it an ideal choice for warm weather. The backless cut with delicate straps adds a touch of sophistication, while the double gauze fabric ensures a soft, lightweight feel against your skin.\n\n🔳𝐅𝐢𝐭\n• Long Crinkle Muslin Maxi Dress, Ankle length\n• You can tie it around your neck with free style ropes, straight or diagonally, as you wish.\n• You can adjust the dress length with free style strings.\n\n𝐊𝐞𝐲 𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Material: Premium cotton double gauze for a soft, breathable feel\n• Design: Strappy, backless design for a stylish, elegant look\n• Versatility: Perfect as a summer we",
  tags: [],
  msrpDollars: 144,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:43.260Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
